<!--
 * @Author: luxiangqiang
 * @Date: 2023-05-15 10:51:23
 * @LastEditors: luxiangqiang
 * @LastEditTime: 2023-05-15 14:42:07
-->
<template>
  <div class="employ-tool">
    <div class="title">本地雇佣工具</div>
    <div class="tools-wrapper">
      <div class="tools">
        <div class="tools-item" v-for="item of tools" :key="item.label">
          <img class="icon" :src="item.icon" alt="icon" />
          <span class="label">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import laborEmploymentRegulations from '@/assets/icons/labor-employment-regulations.svg';
import corporateTaxIcon from '@/assets/icons/corporate-tax-icon.svg';
import governmentDepartmentsRelevantInstitutionsIcon from '@/assets/icons/government-departments-relevant-institutions-icon.svg';
import productPayrollIcon from '@/assets/icons/product-payroll-icon.svg';
import banksInsuranceCompaniesIcon from '@/assets/icons/banks-insurance-companies-icon.svg';

const tools = [
  {
    icon: 'https://video.reta-inc.com/image/default/5DA9FB54559240A89F19B40FDFDEB3FB-6-2.png',
    label: '雇佣成本计算器'
  },
  {
    icon: laborEmploymentRegulations,
    label: '全球劳动法'
  },
  {
    icon: corporateTaxIcon,
    label: '全球税收政策'
  },
  {
    icon: governmentDepartmentsRelevantInstitutionsIcon,
    label: '全球政府机构'
  },
  {
    icon: productPayrollIcon,
    label: '薪酬洞察工具'
  },
  {
    icon: banksInsuranceCompaniesIcon,
    label: '全球银行保险机构'
  },
  {
    icon: 'https://video.reta-inc.com/image/default/0A45888921D74E39A694685B49019598-6-2.png',
    label: '员工工资计算器'
  },
];
</script>

<style scoped lang="less">
.employ-tool {
  .title {
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #1D2129;
  }

  .tools-wrapper {
    margin-top: 16px;
    padding: 0 20px;

    .tools {
      display: grid;
      grid-template-columns: repeat(2, auto);
      gap: 15px;
    }

    .tools-item {
      padding: 15px;
      box-sizing: border-box;
      box-shadow: 0px 2px 16px rgba(135, 172, 255, 0.2);
      border-radius: 4px;
      display: flex;
      align-items: center;

      .icon {
        width: 18px;
        height: 18px;
      }

      .label {
        white-space: nowrap;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #1D2129;
        margin-left: 11px;
      }
    }
  }
}
</style>
